import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AppUnderTest';
import config from './config';
import LoginLayoutA from './LoginLayoutA';
import LoginLayoutB from './LoginLayoutB';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { handleLogin } = useAuth();
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await handleLogin(email, password);
      navigate('/dashboard');
    } catch (err) {
      setError(err.message || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const layoutProps = {
    email,
    setEmail,
    password,
    setPassword,
    error,
    loading,
    onSubmit
  };

  if (config.loginLayout === 'B') {
    return <LoginLayoutB {...layoutProps} />;
  }

  return <LoginLayoutA {...layoutProps} />;
};

export default Login;
